import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { SignUp } from './components/auth/SignUp';
import { SignIn } from './components/auth/SignIn';
import { Register } from './components/auth/Register';
import { InviteTeammates } from './components/auth/InviteTeammates';
import { AuthProvider } from './components/auth/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
export function AppRouter() {
  return <AuthProvider data-id="element-9">
      <BrowserRouter data-id="element-10">
        <Routes data-id="element-11">
          <Route path="/signup" element={<SignUp data-id="element-13" />} data-id="element-12" />
          <Route path="/signin" element={<SignIn data-id="element-15" />} data-id="element-14" />
          <Route path="/register" element={<Register data-id="element-17" />} data-id="element-16" />
          <Route path="/invite" element={<InviteTeammates data-id="element-19" />} data-id="element-18" />
          <Route path="/" element={<ProtectedRoute data-id="element-21">
                <App data-id="element-22" />
              </ProtectedRoute>} data-id="element-20" />
        </Routes>
      </BrowserRouter>
    </AuthProvider>;
}